module.exports = __webpack_public_path__ + "img/s_2.37a0bdde.png";